import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const PageWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 0 56px 0;
`

export const Card = styled('div')<{ theme?: TTheme }>`
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
    padding: 24px;
`
